import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { trapFocus } from "@/lib/trapFocus";

export const ImageLightbox = ({ src, alt, onClose }) => {
  const ref = useRef(null);

  useEffect(() => {
    const opener = document.activeElement;
    const { overflow } = document.body.style;
    document.body.style.overflow = "hidden";
    ref.current?.querySelector("button")?.focus();
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "Tab") trapFocus(e, ref.current);
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = overflow;
      document.removeEventListener("keydown", onKey);
      opener?.focus?.();
    };
  }, [onClose]);

  return createPortal(
    <div
      ref={ref}
      role="dialog"
      aria-modal="true"
      aria-label="Anteprima ingrandita della dashboard"
      className="lightbox fixed inset-0 z-[90] overflow-auto bg-[#050505]/80"
      onClick={(e) => e.target === e.currentTarget && onClose()}
      data-testid="dashboard-lightbox"
    >
      <button
        type="button"
        onClick={onClose}
        className="glass fixed top-4 right-4 z-10 h-11 w-11 rounded-full flex items-center justify-center text-white hover:text-cyan transition-colors"
        aria-label="Chiudi anteprima"
        data-testid="dashboard-lightbox-close"
      >
        <X className="h-5 w-5" />
      </button>
      <div className="min-h-full flex items-center justify-center p-4 sm:p-10" onClick={(e) => e.target === e.currentTarget && onClose()} data-testid="dashboard-lightbox-backdrop">
        <img
          src={src}
          alt={alt}
          className="lightbox-img max-h-[88vh] max-w-full w-auto h-auto object-contain rounded-xl border border-[#1e2024]"
          data-testid="dashboard-lightbox-image"
        />
      </div>
      <p className="pointer-events-none fixed bottom-4 inset-x-0 text-center text-[11px] tracking-[0.2em] uppercase text-[#5b6068]">
        Esc o clic fuori per chiudere
      </p>
    </div>,
    document.body
  );
};
